<template>
  <v-layout class="question">
    <v-flex v-if="required" shrink>
      <RequiredMark />
    </v-flex>
    <v-flex>
      <b><slot /></b>
    </v-flex>
  </v-layout>
</template>

<script>
import RequiredMark from './RequiredMark'

export default {
  name: 'QuestionText',
  components: {
    RequiredMark,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.question {
  background-color: #f5f5f5;
  padding: 8px;
  color: black;
  font-size: 1rem;
}
</style>
